import { render, staticRenderFns } from "./stepValidacoes.vue?vue&type=template&id=41196ad5"
import script from "./stepValidacoes.vue?vue&type=script&lang=ts"
export * from "./stepValidacoes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports